<template>
	<div>
    <div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
      <div class="foot-tab-head">
        <div class="foot-tab-row-label">
          <span class="cursor-pointer underline zt-hover whitespace-nowrap min-w-[18px] pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
          <span class="cursor-pointer underline zt-hover truncate"
                :class="{ '!no-underline' : sortColumn === 'name' }"
                @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
        </div>
        <div class="flex">
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'matches' }"
               @click="sortTable('matches', $event)"><div>M</div></div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'over' }"
               @click="sortTable('over', $event)"><div>O</div></div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'under' }"
               @click="sortTable('under', $event)"><div>U</div></div>
          <div class="foot-tab-row-item pointer-events-none !no-underline !w-12"><div>B</div></div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'avgGoals' }"
               @click="sortTable('avgGoals', $event)"><div>Śr</div></div>
        </div>
      </div>
      <div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }" v-for="(team, index) in leagueTable" :key="team.team_id">
        <div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
          <transition appear name="fade" mode="out-in">
            <p :key="filterKey" class="flex items-center">
              <span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
              <a v-if="!selectedTeamsIds.includes(+team.team_id)"
                 :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
                 class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
              </a>
              <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
              <a v-if="!selectedTeamsIds.includes(+team.team_id)"
                 class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
                 :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
                {{ team.short_name?.length > 0 ? team.short_name : team.name }}
              </a>
              <span v-else class="text-ellipsis line-clamp-1 break-all">
                {{ team.short_name?.length > 0 ? team.short_name : team.name }}
              </span>
            </p>
          </transition>
        </div>
        <transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>
                {{ allMatches(team) }}
              </div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'over' }">
              <div>
                {{ allOver(team) }}
              </div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'under' }">
              <div>
                {{ allUnder(team) }}
              </div>
            </div>
            <div class="foot-tab-row-item !w-12">
              <div>
                {{ allGoals(team) }}
              </div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'avgGoals' }">
              <div>
                {{ avgGoals(team) }}
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
	</div>
</template>

<script>

import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'OverUnderTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'over',
			sortAscending: 0,
			currentSubTab: this.filters[2] ?? 'all',
			overunder: 0.5,
			isLpSet: false,
			displayedTable: 'all',
			teamsSorted: this.teams,
		}
	},
	mounted() {
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.slice().sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[2];
				this.overunder = newVal[1];
        let teams_temp = this.teams.sort(this.sortTeams);
        teams_temp.forEach((team, i) => { team.currentTablePosition = i+1; });
        this.teamsSorted = teams_temp;
			}, 200);
		}
	},
	methods: {
		sortTeams(a,b) {
			let diff = 0;
			switch (this.sortColumn) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'over':
					if (this.sortAscending) {
						diff = this.allOver(a) - this.allOver(b);
					} else {
						diff = this.allOver(b) - this.allOver(a);
					}
					break;
				case 'under':
					if (this.sortAscending) {
						diff = this.allUnder(a) - this.allUnder(b);
					} else {
						diff = this.allUnder(b) - this.allUnder(a);
					}
					break;
				case 'avgGoals':
					if (this.sortAscending) {
						diff = this.avgGoals(a) - this.avgGoals(b);
					} else {
						diff = this.avgGoals(b) - this.avgGoals(a);
					}
					break;
				case 'position':
					if (this.sortAscending) {
						diff = a.currentTablePosition - b.currentTablePosition;
					} else {
						diff = b.currentTablePosition - a.currentTablePosition;
					}
					break;
				default:
					diff = this.allOver(b) - this.allOver(a);
					if (diff === 0) {
						diff = this.avgGoals(b) - this.avgGoals(a);
					}
			}

      if (this.sortColumn === 'name' || diff === 0) {
        if (this.sortAscending) {
          diff = a.name.localeCompare(b.name);
        } else {
          diff = b.name.localeCompare(a.name);
        }
        return diff;
      }

			return diff;
		},
		allOver(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) > this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id && parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) > this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) > this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
		},
		allUnder(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) < this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id && parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) < this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id && parseInt(match.localteam_goals) + parseInt(match.visitorteam_goals) < this.overunder) {
						return sum + 1;
					} else {
						return sum;
					}
				}, 0);
		},
		avgGoals(team) {
			let allGoals = this.allGoals(team);
			let colonIndex = allGoals.indexOf(':');
			let goalsFor = parseInt(allGoals.substr(0, colonIndex));
			let goalsAgainst = parseInt(allGoals.substr(colonIndex + 1));
			let allMatches = this.allMatches(team);
			return allMatches > 0 ? ((goalsFor + goalsAgainst) / this.allMatches(team)).toFixed(1) : 0;
		},
		allGoals(team, own = false) {
			if (this.currentSubTab === 'all') {
				let goals = this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.localteam_goals);
					} else {
						return sum + parseInt(match.visitorteam_goals);
					}
				}, 0);
				if (own === false) {
					goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
						if (match.visitorteam_id === team.team_id) {
							return sum + parseInt(match.localteam_goals);
						} else {
							return sum + parseInt(match.visitorteam_goals);
						}
					}, 0);
				}
				return goals;
			} else if (this.currentSubTab === 'home') {
				let goals = this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.localteam_goals);
					} else {
						return sum;
					}
				}, 0);
				if (own === false) {
					goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
						if (match.localteam_id === team.team_id) {
							return sum + parseInt(match.visitorteam_goals);
						} else {
							return sum;
						}
					}, 0);
				}
				return goals;
			} else if (this.currentSubTab === 'away') {
				let goals = this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.visitorteam_goals);
					} else {
						return sum;
					}
				}, 0);
				if (own === false) {
					goals += ':' + this.getTeamMatches(team).reduce((sum, match) => {
						if (match.visitorteam_id === team.team_id) {
							return sum + parseInt(match.localteam_goals);
						} else {
							return sum;
						}
					}, 0);
				}
				return goals;
			}
		},
	}
}

</script>
<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>